import React from "react";
import styled from "styled-components";

import { history } from "../../Layout";
import { media } from "utils/style";

const NoMatch = () => (
  <Container>
    <H1>Sorry, we can't find that page.</H1>

    <div style={{ maxWidth: "450px" }}>
      <P>
        For logged in customers, you can navigate back to the{" "}
        <a href="/privacy/secure/your-data">home page</a>.
      </P>
      <P>
        If you are not logged in you can navigate back to our{" "}
        <a href="/privacy/your-data">logged out landing page</a>.
      </P>
      <P>
        Otherwise, you can try and navigate back the{" "}
        <Button role="link" onClick={() => history.goBack()}>
          previous page
        </Button>
        .
      </P>
    </div>
  </Container>
);

export default NoMatch;

const Container = styled.div`
  max-width: 1272px;
  padding: 80px 16px;

  ${media.mobile`
    padding: 40px 16px;  
  `}
`;

const H1 = styled.h1`
  font-size: 32px;
  line-height: 30px;
  margin-bottom: 20px;

  ${media.mobile`
    font-size: 25px;	
    line-height: 24px;
  `}
`;

const P = styled.p`
  margin: 12px 0;
`;

const Button = styled.button`
  background: 0;
  border: 0;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;

  ${media.mobile`
    font-size: 12px;
    line-height: 14px;
  `}
`;
